<template>
  <div class="task-detail">
    <div class="header">
      <div class="return-btn" @click="handleCancel">
          <span>&lt;</span> <span>{{ $t('admin.rpa.btn.return') }}</span>
      </div>
    </div>
    <div class="info-container">
      <div class="base-info">
        <div class="account-info">
          <div class="info-container account">
            <div class="container-title">
              <div class="title">
                <span>{{ $t(`${i18nPrefix}.label.accountInfo`) }}</span>
              </div>
              <span class="title-suffix">{{ taskInfo.channel.i18nName || '' }}</span>
            </div>
            <div class="company-name">{{ taskInfo.company.i18nName || '' }}</div>
            <div
              v-for="(item, index) in accountInfoLines"
              class="account-info-line"
              :key="index"
              :class="item.className"
            >{{ item.value }}</div>
            <div v-if="taskInfo.channel.id === 2" class="other-config-info-line">{{ $t(`${i18nPrefix}.label.ignoreNoIdJob`) }}: {{ $t(`common.label.${taskInfo.ignore_no_id_job ? 'yes' : 'no'}`) }}</div>
            <i class="edit-icon el-icon-edit" @click="handleEditTask"></i>
          </div>
          <div class="info-container bind">
            <label class="label">{{ $t(`${i18nPrefix}.label.bind`) }}</label>
            <div class="qr-code-image">
              <img :src="weChatQrUrl"/>
            </div>
          </div>
        </div>
        <div class="task-info">
          <div v-loading="monitor.loading" class="monitor-wrapper"  @click="handleMonitorClick">
            <div v-show="showControlBtn" class="monitor-btn-container" :class="monitor.src && monitor.image ? 'mask':''">
              <div class="control-btn" @click.stop="handleControlBtnClick">{{ $t(`${i18nPrefix}.btn.needOperate`) }}</div>
            </div>
            <div v-show="showBotActionLoading" class="monitor-show-loading">
              <div class="loading-text">
                <span>{{ $t(`${i18nPrefix}.label.restarting`) }}</span>
                <span class="dot">...</span>
              </div>
            </div>
            <div class="monitor">
              <img v-if="monitor.src && monitor.image" :src="monitor.image"/>
            </div>
          </div>
          <div class="operation">
            <div class="status-info">{{ taskLauncherStatusLabel }}</div>
            <el-popconfirm
              :confirm-button-text='$t(`${i18nPrefix}.message.operatorConfirm`)'
              :cancel-button-text='$t(`${i18nPrefix}.message.operatorCancel`)'
              icon="el-icon-info"
              icon-color="red"
              :disabled="!taskInfo.can_operate || showBotActionLoading"
              :title="$t(`${i18nPrefix}.message.operatorConfirmMessage`)"
              @confirm="handleEnableChange"
            >
              <el-switch
                slot="reference"
                :value="taskIsEnable"
                class="status-switch"
                :disabled="!taskInfo.can_operate || showBotActionLoading"
                :inactive-text="taskStatusLabel"
              >
              </el-switch>
            </el-popconfirm>
            <el-popconfirm
              :confirm-button-text='$t(`${i18nPrefix}.message.operatorConfirm`)'
              :cancel-button-text='$t(`${i18nPrefix}.message.operatorCancel`)'
              icon="el-icon-info"
              icon-color="red"
              :disabled="!taskInfo.can_operate || showBotActionLoading"
              :title="$t(`${i18nPrefix}.message.operatorConfirmMessage`)"
              @confirm="handleRestartBtn"
            >
              <div class="restart-btn" slot="reference" :class="taskInfo.can_operate && !showBotActionLoading? '': 'disable'">
                <label class="label">{{ $t(`${i18nPrefix}.btn.restart`) }}</label>
                <i class="btn-icon el-icon-refresh-right"></i>
              </div>
            </el-popconfirm>
          </div>
        </div>
      </div>
      <div class="counter-info">
        <CounterList
          class="job"
          v-loading="countData[featureTypeJobPosting].loading"
          :titleI18nKey="`${i18nPrefix}.label.job`"
          :data="jobCountData"
        >
          <template #titleBtn>
            <Dropdown
             v-model="countData[featureTypeJobPosting].day"
            :data="dayRangeList"
            @change="handelDayChange(featureTypeJobPosting)"/>
          </template>
        </CounterList>
        <CounterList
          class="resume"
          v-loading="countData[featureTypeDownload].loading"
          :titleI18nKey="`${i18nPrefix}.label.resume`"
          :data="resumeCountData"
        >
         <template #titleBtn>
            <Dropdown
              v-model="countData[featureTypeDownload].day"
              :data="dayRangeList"
              @change="handelDayChange(featureTypeDownload)"/>
          </template>
        </CounterList>
      </div>
    </div>
    <div class="resume-download-list-container" v-if="hasSuperAdminPermission && featureType === featureTypeDownload">
      <!-- <div class="download-button-container" @click="handelDownloadResume">
        {{ $t('admin.rpa.btn.download') }}
      </div> -->
      <el-collapse v-model="activeNames">
        <el-collapse-item :title="$t('admin.rpa.label.resumeDownloadListTitle')" name="1">
          <NoBorderTable
            class="resume-table"
            :noOperation="true"
            :noHeader="true"
            :tableColumns="tableColumns"
            :listData="resumeDownloadList"
            :rowClassName="tableRowClassName"
          >
            <template #resumeName="{ row }">
              <div class="resume-name-container">
                {{ row.file_name }}
              </div>
            </template>
            <template #status="{ row }">
              <template v-if="statusMapping[row.status]">
                <div class="status-container" :class="statusMapping[row.status].class">
                  <van-icon class="status-icon" :name="statusMapping[row.status].iconName"></van-icon>
                  <span class="status-name">{{ statusMapping[row.status].label }}</span>
                </div>
              </template>
            </template>
          </NoBorderTable>
          <el-pagination
            class="pagination"
            background
            layout="total, sizes, prev, pager, next"
            :total="pageInfo.total"
            :page-count="pageInfo.page"
            :page-size="pageInfo.pageSize"
            @current-change='handelPageChange'
            @size-change='handelSizeChange'
            >
          </el-pagination>
        </el-collapse-item>
      </el-collapse>
      <RectLoading v-show="showListLoading"/>
    </div>
    <el-dialog
      width="80%"
      :visible.sync="dialog.show"
      :before-close="cleanIframe"
    >
      <div v-loading="dialog.loading" class="iframe-container">
        <iframe ref="iframe" @load="handleIframeLoad" class="control-container" :src="controlIframeSrc"></iframe>
      </div>
    </el-dialog>
    <el-dialog
      width="80%"
      :visible.sync="monitor.dialog.show"
    >
      <div v-loading="monitor.dialog.loading" class="image-container">
        <img v-if="monitor.dialog.show" :src="monitor.image"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import Dropdown from '@/components/formEditor/dropdown.vue'
import NoBorderTable from '@/components/tableList/noBorderTable.vue'
import CounterList from './components/counterList.vue'
import RectLoading from '@/components/loading/rectLoading.vue'
import { mapActions } from 'vuex'
import { addI18nProperty, createI18nProperty } from '@/i18n'
import moment from 'moment'
import {
  FEATURE_TYPE,
  CHANNEL_ID,
  ACTION_TYPE,
  LAUNCHER_STATUS_INFO_MAP,
  LAUNCHER_HAS_SCREENSHOT_STATUS,
  LAUNCHER_DISPLAY_STATUS,
  dayRange
} from '@/constant/rpa'

export default {
  props: {
    taskBackend: { type: String, default: 'legacy' }
  },
  components: {
    Dropdown,
    CounterList,
    NoBorderTable,
    RectLoading
  },
  data () {
    const featureTypeDownload = FEATURE_TYPE.DOWNLOAD_RESUME
    const featureTypeJobPosting = FEATURE_TYPE.JOB_POSTING
    return {
      i18nPrefix: 'admin.rpa',
      featureTypeDownload,
      featureTypeJobPosting,
      taskIsEnable: false,
      showListLoading: false,
      showBotActionLoading: false,
      autoGetBotActionStatus: false,
      activeNames: ['1'],
      screenShotImgUrl: '',
      weChatQrUrl: '',
      controlIframeSrc: null,
      taskSetting: {
        autoRefresh: true,
        refreshTime: 60000
      },
      botStatus: '',
      statusMapping: {
        success: {
          label: 'Success',
          class: 'success',
          iconName: 'passed'
        },
        processing: {
          label: 'Processing',
          class: 'processing',
          iconName: 'more-o'
        },
        fail: {
          label: 'Fail',
          class: 'fail',
          iconName: 'close'
        },
        pending: {
          label: 'Pending',
          class: 'Pending',
          iconName: 'clock-o'
        }
      },
      pageInfo: {
        page: 1,
        total: 0,
        pageSize: 10
      },
      resumeDownloadList: [],
      taskInfo: {
        id: null,
        channel: {
          i18nName: null
        },
        company: {
          i18nName: null
        },
        account: {},
        feature_type: null,
        is_enabled: false,
        can_operate: false
      },
      countData: {
        [featureTypeDownload]: {
          data: {
            total: 0,
            processing: 0
          },
          day: 0,
          loading: false
        },
        [featureTypeJobPosting]: {
          data: {
            posted: 0,
            post_in_queue: 0,
            closed: 0,
            close_in_queue: 0
          },
          day: 0,
          loading: false
        }
      },
      screenShotUrl: null,
      screenTimer: null,
      dialog: {
        show: false,
        loading: false,
        // 接管弹窗轮次，用于拒绝关闭或重新打开前的迟到请求和布局回调。
        sessionGeneration: 0,
        layoutTimer: null
      },
      monitor: {
        loading: false,
        autoRefresh: true,
        // 实时查看轮次，用于拒绝上一轮连接或截图请求的迟到结果。
        sessionGeneration: 0,
        frame: 2,
        socket: null,
        objectUrl: null,
        src: null,
        image: null,
        dialog: {
          show: false,
          loading: false
        }
      }
    }
  },
  computed: {
    taskRoutePrefix () {
      return this.taskBackend === 'new' ? '/v-admin/rpa-new' : '/v-admin/rpa'
    },
    hasSuperAdminPermission () {
      return this.$parent.hasSuperAdminPermission
    },
    showControlBtn () {
      return LAUNCHER_STATUS_INFO_MAP.WAIT_VERIFY.statusList.includes(this.botStatus)
    },
    accountInfoLines () {
      const result = []
      if (this.taskInfo.account.job_51_user_name) {
        result.push({ value: this.taskInfo.account.job_51_user_name })
      }
      result.push(
        { value: this.taskInfo.account.account },
        { value: this.taskInfo.account.password })
      return result
    },
    taskStatusLabel () {
      return this.$t(`${this.i18nPrefix}.btn.status.${this.taskIsEnable ? 'enable' : 'disable'}`)
    },
    taskLauncherStatusLabel () {
      const statusKey = _.findKey(LAUNCHER_STATUS_INFO_MAP, ({ statusList }) => statusList.includes(this.botStatus))
      return this.$t(`${this.i18nPrefix}.launcherDisplayStatus.${statusKey || LAUNCHER_DISPLAY_STATUS.UNKNOWN}`)
    },
    dayRangeList () {
      return _.map(dayRange, item => {
        return { labelI18nKey: `${this.i18nPrefix}.dayRange.${item}`, value: item }
      })
    },
    jobCountData () {
      const countData = this.countData[this.featureTypeJobPosting].data
      const posted = countData?.posted || 0
      const postInQueue = countData?.post_in_queue || 0
      const closed = countData?.closed || 0
      const closeInQueue = countData?.close_in_queue || 0
      const data = [
        { labelI18nKey: `${this.i18nPrefix}.label.postedJob.new`, value: posted },
        { labelI18nKey: `${this.i18nPrefix}.label.inQueueJob.new`, value: postInQueue },
        { labelI18nKey: `${this.i18nPrefix}.label.postedJob.close`, value: closed },
        { labelI18nKey: `${this.i18nPrefix}.label.inQueueJob.close`, value: closeInQueue }
      ]
      return data
    },
    resumeCountData () {
      const count = this.countData[this.featureTypeDownload].data
      const total = count.total || 0
      const handled = count?.succeed || 0
      const data = [
        { labelI18nKey: `${this.i18nPrefix}.label.downloadResume.downloaded`, value: total },
        { labelI18nKey: `${this.i18nPrefix}.label.downloadResume.handled`, value: handled },
        { labelI18nKey: `${this.i18nPrefix}.label.downloadResume.gap`, value: total - handled }
      ]
      return data
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t('admin.rpa.label.table.header.resumeName'),
          dataKey: 'resume_name',
          slotName: 'resumeName',
          width: '105'
        },
        {
          label: this.$t('admin.rpa.label.table.header.candidateName'),
          dataKey: 'candidate.name',
          width: '100'
        },
        {
          label: this.$t('admin.rpa.label.table.header.reqId'),
          dataKey: 'job.id'
        },
        {
          label: this.$t('admin.rpa.label.table.header.downloadTime'),
          dataKey: 'download_start_time',
          formatter: this.formatDate,
          width: '100'
        },
        {
          label: this.$t('admin.rpa.label.table.header.uploadToAjingaTime'),
          dataKey: 'import_end_time',
          formatter: this.formatDate,
          width: '130'
        },
        {
          label: this.$t('admin.rpa.label.table.header.status'),
          dataKey: 'status',
          slotName: 'status'
        }
      ]
      return columns
    },
    taskId () {
      return this.$route.params.taskId
    },
    featureType () {
      return this.taskInfo.feature_type
    }
  },
  async created () {
    await this.initData()
  },
  beforeDestroy () {
    this.stopMonitor()
    this.cleanIframe()
    if (this.taskSetting.autoRefresh) {
      this.taskSetting.autoRefresh = false
    }
    this.showBotActionLoading = false
    this.autoGetBotActionStatus = false
  },
  methods: {
    ...mapActions('rpa', ['getQrUrl', 'getTaskList', 'getTaskById', 'getResumeDownloadData', 'getReportData',
      'getTaskScreenshot', 'getTaskControl', 'getMonitorImage', 'updateTaskAction', 'updateTask',
      'getDownloadResumeReportData', 'getPostingJobReportData', 'getTaskAction']),
    async initData () {
      await this.initTaskInfo()
      if (!this.taskSetting.autoRefresh) return
      if (this.$route.query.needVerify === '1') {
        this.handleControlBtnClick()
      }
      this.initMonitor()
      this.initQrCode()
      this.initCountData(FEATURE_TYPE.DOWNLOAD_RESUME)
      this.initCountData(FEATURE_TYPE.JOB_POSTING)
      if (this.hasSuperAdminPermission) {
        this.initResumeDownloadData()
      }
      setTimeout(this.refreshTaskInfo, this.taskSetting.refreshTime)
    },
    async initResumeDownloadData () {
      this.handelPageChange(1)
    },
    async initTaskInfo () {
      const params = {
        task_id: this.taskId
      }
      const resp = await this.getTaskList({ ...params, taskBackend: this.taskBackend })
      if (resp) {
        const taskInfo = resp.task
        const channelInfo = taskInfo.channel
        const channelIdKey = _.findKey(CHANNEL_ID, val => val === channelInfo.id)
        createI18nProperty(channelInfo, 'i18nName', `${this.i18nPrefix}.channelName.${channelIdKey}`)
        addI18nProperty(taskInfo.company, 'i18nName', 'cn_name', 'name')
        this.taskInfo = taskInfo
        this.botStatus = resp.status
        this.taskIsEnable = this.taskInfo.is_enabled
      }
    },
    async initCountData (featureType) {
      if (!featureType) {
        return
      }
      this.countData[featureType].loading = true
      try {
        const params = {
          channel_id: this.channelId,
          days_delta: this.countData[featureType].day,
          task_id: this.taskId
        }
        let requestMethod = this.getDownloadResumeReportData
        if (featureType === FEATURE_TYPE.JOB_POSTING) {
          requestMethod = this.getPostingJobReportData
        }
        const resp = await requestMethod(params)
        if (resp) {
          this.countData[featureType].data = resp
        }
      } finally {
        this.countData[featureType].loading = false
      }
    },
    async initMonitor () {
      this.stopMonitor()
      if (!this.taskSetting.autoRefresh || !this.hasSuperAdminPermission || !LAUNCHER_HAS_SCREENSHOT_STATUS.includes(this.botStatus)) {
        return
      }
      const monitor = this.monitor
      const monitorGeneration = monitor.sessionGeneration
      monitor.loading = true
      monitor.autoRefresh = true
      try {
        const resp = await this.getTaskScreenshot({ task_id: this.taskId, taskBackend: this.taskBackend })
        if (!monitor.autoRefresh || monitorGeneration !== monitor.sessionGeneration) return
        monitor.src = resp?.screenshot || null
        if (resp?.view_stream) {
          this.connectMonitorStream(resp.view_stream, monitorGeneration)
        } else if (monitor.src) {
          this.refreshMonitor(monitorGeneration)
        } else {
          // STARTING 时通道可能尚未建立；不因首次无地址永久停止查看。
          this.screenTimer = setTimeout(() => this.initMonitor(), 1000 / monitor.frame)
        }
      } catch (err) {
        if (monitorGeneration === monitor.sessionGeneration) this.stopMonitor()
        // eslint-disable-next-line no-console
        console.error(err)
      } finally {
        if (monitorGeneration === monitor.sessionGeneration) monitor.loading = false
      }
    },
    stopMonitor () {
      clearTimeout(this.screenTimer)
      this.screenTimer = null
      this.monitor.sessionGeneration += 1
      if (this.monitor.socket) {
        this.monitor.socket.close()
        this.monitor.socket = null
      }
      if (this.monitor.objectUrl) {
        URL.revokeObjectURL(this.monitor.objectUrl)
        this.monitor.objectUrl = null
      }
      this.monitor.autoRefresh = false
      this.monitor.loading = false
      this.monitor.src = null
      this.monitor.image = null
    },
    connectMonitorStream (viewStream, monitorGeneration) {
      // viewStream 含同源连接路径和一次性查看凭据；monitorGeneration 绑定本次查看轮次。
      const monitor = this.monitor
      const endpoint = new URL(viewStream.path, window.location.href)
      if (endpoint.origin !== window.location.origin || !viewStream.token) {
        this.stopMonitor()
        return
      }
      endpoint.protocol = endpoint.protocol === 'https:' ? 'wss:' : 'ws:'
      const socket = new WebSocket(endpoint.href)
      monitor.socket = socket
      const isCurrentMonitorConnection = () => monitor.autoRefresh && monitorGeneration === monitor.sessionGeneration && monitor.socket === socket
      socket.onopen = () => {
        if (!isCurrentMonitorConnection()) return socket.close()
        // token 只在首条消息中提交，不出现在请求 URL 或访问日志中。
        socket.send(JSON.stringify({ type: 'claim-view', token: viewStream.token }))
      }
      socket.onmessage = event => {
        if (!isCurrentMonitorConnection()) return
        if (typeof event.data === 'string') {
          try {
            if (JSON.parse(event.data).type === 'error') socket.close()
          } catch (error) {
            socket.close()
          }
          return
        }
        const previousUrl = monitor.objectUrl
        monitor.objectUrl = URL.createObjectURL(new Blob([event.data], { type: 'image/jpeg' }))
        monitor.image = monitor.objectUrl
        monitor.loading = false
        if (previousUrl) URL.revokeObjectURL(previousUrl)
      }
      socket.onerror = () => socket.close()
      socket.onclose = () => {
        if (!isCurrentMonitorConnection()) return
        monitor.socket = null
        if (monitor.objectUrl) URL.revokeObjectURL(monitor.objectUrl)
        monitor.objectUrl = null
        monitor.image = null
        // 换页会使旧通道失效，重新通过 API 鉴权，不能复用已核销的凭据。
        this.screenTimer = setTimeout(() => {
          if (monitor.autoRefresh && monitorGeneration === monitor.sessionGeneration) this.initMonitor()
        }, 1000)
      }
    },
    async refreshMonitor (monitorGeneration = this.monitor.sessionGeneration) {
      const monitor = this.monitor
      if (!monitor.autoRefresh || monitorGeneration !== monitor.sessionGeneration || !monitor.src) return
      let resp = null
      try {
        resp = await this.getMonitorImage(monitor.src)
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
      }
      // 离开页面或新一轮查看开始后，不接受旧请求，也不恢复旧轮询。
      if (!monitor.autoRefresh || monitorGeneration !== monitor.sessionGeneration) return
      if (resp && resp.value && !resp.value.error) {
        monitor.image = `data:image/jpeg;base64,${resp.value}`
      } else if (resp?.value?.error === 'browser_frame_unavailable') {
        // worker 异步启动推帧，首帧未到或换页期间继续等待。
        monitor.image = null
      } else {
        this.stopMonitor()
        return
      }
      this.screenTimer = setTimeout(() => this.refreshMonitor(monitorGeneration), 1000 / monitor.frame)
    },
    async refreshTaskInfo () {
      if (!this.taskSetting?.autoRefresh) {
        return
      }
      const params = {
        task_id: this.taskId
      }
      const resp = await this.getTaskList({ ...params, taskBackend: this.taskBackend })
      if (resp) {
        const oldStatus = this.botStatus
        const taskInfo = resp.task
        const channelInfo = taskInfo.channel
        const channelIdKey = _.findKey(CHANNEL_ID, val => val === channelInfo.id)
        createI18nProperty(channelInfo, 'i18nName', `${this.i18nPrefix}.channelName.${channelIdKey}`)
        addI18nProperty(taskInfo.company, 'i18nName', 'cn_name', 'name')
        this.taskInfo = taskInfo
        this.botStatus = resp.status
        this.taskIsEnable = this.taskInfo.is_enabled

        if (!this.monitor.autoRefresh || this.botStatus !== oldStatus) {
          this.initMonitor()
        }
        if (this.taskSetting && this.taskSetting.autoRefresh) {
          setTimeout(this.refreshTaskInfo, this.taskSetting.refreshTime)
        }
      }
    },
    async initQrCode () {
      const params = {
        task_id: this.taskId
      }
      const resp = await this.getQrUrl(params)
      if (resp) {
        this.weChatQrUrl = resp
      }
    },
    async handleEnableChange () {
      if (!this.taskInfo.can_operate) {
        return
      }
      const params = {
        id: this.taskInfo.id,
        is_enabled: !this.taskInfo.is_enabled
      }
      await this.updateTask({ ...params, taskBackend: this.taskBackend })
      this.taskIsEnable = !this.taskIsEnable
    },
    async handleRestartBtn () {
      if (!this.taskInfo.can_operate) {
        return
      }
      const params = {
        task_id: this.taskId,
        action: ACTION_TYPE.RESTART
      }
      const resp = await this.updateTaskAction({ ...params, taskBackend: this.taskBackend })
      if (resp?.action_uid) {
        this.showBotActionLoading = true
        this.autoGetBotActionStatus = true
        this.stopMonitor()
        this.cleanIframe()
        this.getBotActionStatus(resp.action_uid)
      }
    },
    handelDownloadResume () {

    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'gray-background'
      }
    },
    formatDate (date) {
      return date ? moment(date).format('YYYY-MM-DD HH:mm') : ''
    },
    handleEditTask () {
      if (this.taskId) {
        this.$router.push(`${this.taskRoutePrefix}/task/${this.taskId}/edit`)
      }
    },
    async handleControlBtnClick () {
      if (!this.showControlBtn || !this.taskSetting.autoRefresh) return
      this.cleanIframe()
      const controlGeneration = this.dialog.sessionGeneration
      this.dialog.show = true
      this.dialog.loading = true
      try {
        // 只在实际打开接管时获取新租约，不复用已领取或过期的 iframe 地址。
        const resp = await this.getTaskControl({ task_id: this.taskId, taskBackend: this.taskBackend })
        if (!this.dialog.show || controlGeneration !== this.dialog.sessionGeneration) return
        this.controlIframeSrc = resp?.control_path || ''
      } finally {
        if (controlGeneration === this.dialog.sessionGeneration && !this.controlIframeSrc) {
          this.dialog.loading = false
        }
      }
    },
    handleMonitorClick () {
      if (this.monitor.src && this.monitor.image) {
        this.monitor.dialog.show = true
      }
    },
    handleIframeLoad () {
      // 旧 Selenium DevTools 保留原布局适配；新接管页自行显示连接和首帧状态。
      if (/\/rpa\/[^/]+\/control\//.test(this.controlIframeSrc || '')) {
        this.adjustLegacyControlLayout(this.dialog.sessionGeneration)
        return
      }
      if (this.controlIframeSrc) this.dialog.loading = false
    },
    adjustLegacyControlLayout (controlGeneration) {
      // controlGeneration 绑定本次接管弹窗，关闭后不再等待或修改旧 iframe。
      if (!this.dialog.show || controlGeneration !== this.dialog.sessionGeneration) return
      const contentDocument = this.$refs.iframe?.contentDocument
      const screencast = contentDocument?.querySelector('.screencast')
      if (!screencast) {
        this.dialog.layoutTimer = setTimeout(() => this.adjustLegacyControlLayout(controlGeneration), 500)
        return
      }
      // 隐藏 DevTools 工具栏和侧栏。
      screencast.firstElementChild.style.display = 'none'
      screencast.parentElement.lastElementChild.style.display = 'none'
      screencast.parentElement.shadowRoot.querySelector('div .shadow-split-widget-sidebar')?.remove()
      screencast.parentElement.shadowRoot.querySelector('div .shadow-split-widget-resizer')?.remove()
      screencast.querySelector('.screencast-viewport').style.margin = 'auto'
      contentDocument.dispatchEvent(new Event('resize'))
      this.dialog.loading = false
    },
    cleanIframe () {
      clearTimeout(this.dialog.layoutTimer)
      this.dialog.layoutTimer = null
      this.dialog.sessionGeneration += 1
      this.controlIframeSrc = ''
      this.dialog.show = false
      this.dialog.loading = false
    },
    async handelPageChange (val) {
      this.showListLoading = true
      try {
        this.pageInfo.page = val
        const resp = await this.getResumeDownloadData({
          task_id: this.taskInfo.id,
          page_num: this.pageInfo.page,
          page_size: this.pageInfo.pageSize
        })
        if (resp) {
          this.pageInfo.total = resp.total_count
          this.resumeDownloadList = resp.list
        }
      } finally {
        this.showListLoading = false
      }
    },
    handelSizeChange (val) {
      this.pageInfo.pageSize = val
      this.handelPageChange(this.pageInfo.page)
    },
    handelDayChange (type) {
      if (!type) {
        return
      }
      this.initCountData(type)
    },
    handleCancel () {
      this.$router.push(`${this.taskRoutePrefix}/index`)
    },
    async getBotActionStatus (actionUid) {
      if (!actionUid) {
        this.autoGetBotActionStatus = false
        return
      }
      const params = {
        task_id: this.taskId,
        action_uid: actionUid
      }
      const resp = await this.getTaskAction({ ...params, taskBackend: this.taskBackend })
      if (resp === 'PENDING' && this.autoGetBotActionStatus) {
        setTimeout(this.getBotActionStatus, 1000, actionUid)
      } else {
        this.showBotActionLoading = false
        this.initMonitor()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.task-detail {
  .header {
    background: #FFFFFF;
    padding: 20px 20px 0 20px;

    .return-btn {
      cursor: pointer;
      font-size: 16px;

      > span {
        &:last-child {
          margin-left: 5px;
        }
      }
    }
  }

  .info-container {
    padding: 20px;
    border-radius: 5px;
    background: #fff;

    .base-info {
      display: flex;
      margin-bottom: 40px;
      justify-content: space-between;

      .account-info {
        width: 38%;

        .info-container {
          border-radius: 5px;
          background: #f7f7f7;

          & + .info-container {
            margin-top: 20px;
          }

          .container-title {
            display: flex;
            align-items: flex-end;

            .title {
              flex: 1;
              margin-bottom: 5px;
              padding-bottom: 5px;
              border-bottom: 1px solid #666666;
              font-size: 18px;
              font-weight: bold;
              color: #232323;
              position: relative;

              &::before {
                content: '';
                display: block;
                width: 30px;
                border-bottom: 4px solid #666666;
                position: absolute;
                right: 0;
                bottom: 0;
              }
            }

            .title-suffix {
              margin-left: 10px;
              line-height: 1;
              font-size: 20px;
              color: #606060;
            }
          }

          &.account {
            position: relative;

            .company-name {
              margin-top: 15px;
              font-size: 20px;
              color: #606060;
            }

            .account-info-line {
              font-size: 16px;
              color: #606060;
            }

            .other-config-info-line {
              margin-top: 10px;
              padding-top: 6px;
              border-top: 1px solid #dcdfe6;
              font-size: 16px;
              color: #606060;
            }

            .edit-icon {
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 18px;
              cursor: pointer;
            }
          }

          &.bind {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .label {
              font-size: 20px;
              color: #606060;
            }

            .qr-code-image {
              width: 150px;
              height: 150px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }

      .task-info {
        display: flex;
        width: 58%;
        height: 500px;
        border: 1px solid #dcdfe6;
        border-top: 0;
        flex-direction: column;

        .monitor-wrapper {
          flex: 1px;
          position: relative;

          .monitor-btn-container {
            display: flex;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;

            &.mask {
              background-color: rgba($color: #000000, $alpha: 0.3);
              opacity: 1;
            }

            .control-btn {
              margin: auto;
              padding: 4px 8px;
              font-size: 16px;
              border: 1px solid #606060;
              color: #fff;
              cursor: pointer;
            }
          }

          .monitor-show-loading {
            position: absolute;
            display: flex;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            font-size: 18px;

            .loading-text {
              margin: auto;
              cursor: default;

              .dot {
                font-family: simsun;
                display: inline-block;
                width: 1.5em;
                animation: dot 3s infinite step-start;
                overflow: hidden;
                vertical-align: bottom;
              }

              @keyframes dot {
                0% {width: 0; margin-right: 1.5em;}
                33% {width: 0.5em; margin-right: 1em;}
                66% {width: 1.0em; margin-right: 0.5em;}
                100% {width: 1.5em; margin-right: 0;}
              }

            }
          }

          .monitor {
            height: 100%;
            background: rgba($color: #000000, $alpha: 0.4);

            > img {
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
          }
        }

        .operation {
          display: flex;
          padding: 10px;
          border-top: 1px solid #dcdfe6;
          justify-content: flex-end;
          align-items: center;

          .status-info {
            margin-left: 0;
            margin-right: auto;
            font-size: 14px;
          }

          .status-switch {
            margin-right: 30px;

            ::v-deep {
              .el-switch__label.is-active {
                color: inherit;
              }
            }
          }

          .restart-btn {
            margin-right: 0px;
            cursor: pointer;

            &:hover:not(.disable) {
              .btn-icon {
                transform: rotateZ(360deg);
              }
            }

            .label {
              font-size: 14px;
              cursor: pointer;
              vertical-align: middle;
            }

            &.disable {
              opacity: .6;
              cursor: not-allowed;

              .label {
                cursor: not-allowed;
              }
            }

            .btn-icon {
              margin-left: 5px;
              vertical-align: middle;
              font-size: 24px;
              color: #39a7c9;
              transition: transform .3s;
              transform: rotateZ(0);
            }
          }
        }
      }
    }

    .counter-info {
      display: flex;
      justify-content: space-between;

      .counter-list-container {
        width: 48%;
      }
    }
  }

  .resume-download-list-container {
    margin-top: 20px;
    position: relative;
    background-color: #FFFFFF;

    .download-button-container {
      right: 40px;
      position: absolute;
      background-color: #39a7c9;
      color: #FFFFFF;
      top: 8px;
      padding: 8px 15px;
      cursor: pointer;
    }

    .resume-name-container {
      text-align: left;
      margin-left: 30px;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .status-container {
      display: flex;
      margin-left: 15px;
      align-items: center;
      justify-content: flex-start;

      .status-icon::before {
        // color: #FFFFFF;
        border-radius: 50%;
        font-size: 17px;
        border: 0;
      }

      .status-name {
        margin-left: 10px;
      }

      &.success {
        color: #3f863e;

        // .status-icon::before {
        //   background-color: #3f863e;
        // }
      }

      &.fail {
        color: #881818;

        // .status-icon::before {
        //   background-color: #881818;
        // }
      }

      &.processing {
        color: #186e88;

        // .status-icon::before {
        //   background-color: #186e88;
        // }
      }

    }

    .pagination {
      text-align: right;
      margin-right: 10px;
      padding: 10px;
    }

    ::v-deep .el-collapse {
      border: 0px;

      .el-collapse-item {
        margin-top: 15px;
      }

      .el-collapse-item__header {
        padding: 0 20px;
        font-size: 16px;
        border: 0px;
        color: #000000;
        font-weight: 600;

        > i {
          margin-left: 15px;
          transform: rotate(-90deg);

          &.is-active {
            transform: rotate(90deg);
          }
        }
      }

      .el-collapse-item__wrap {
        margin-top: 10px;
        border: 0px;
      }

      .el-collapse-item__content {
        padding: 0 25px 20px 25px;
      }

      .el-table__header {
        .el-table__cell {
          font-size: 14px;
          padding: 20px 0;
          color: #000000;
          font-weight: 600;

          &.is-leaf {

            &:first-child {
              text-align: left;
              padding-left: 25px;
            }

            background-color: #FFFFFF;
          }
        }
      }

      .el-table__body {
          .el-table__cell {
            padding: 20px 0;

            .cell {
              padding: 0 5px;
            }
          }

          .gray-background {
            background: #f7f7f7;
          }
      }
    }

    ::v-deep .loading-mask {
      position: absolute;
    }
  }

  .iframe-container {
    overflow: hidden;

    .control-container {
      width: 100%;
      height: 46vw;
      border: 0;
    }
  }

  .image-container {
    text-align: center;

    > img {
      width: 90%;
    }
  }
}
</style>
